export default __webpack_public_path__ + "static/media/tror_black_large.81eebef1.png";